import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import {getFirestore, serverTimestamp } from "firebase/firestore";

import firebaseApp from "../firebase/credenciales";

//import 'react-quill/dist/quill.snow.css';
import '../styles/documentos.css'

import añadirDocumento from '../functions/añadirDocumento';
import alertaOk from '../functions/alertaOk';
import alertaError from '../functions/alertaError';

const GenerarDocumentos = ({ usuario }) => {

  const db = getFirestore(firebaseApp);

  const ruc = usuario.ruc;

  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [htmlContent, setHtmlContent] = useState('');
  const [DNI, setDNI] = useState('');

  var toolbarOptions = [
    ['image']        //Solo para adjuntar imagenes

  ];

  const module = {
    toolbar: toolbarOptions,
  };


  let tableFirma = `<h2><strong>Previsualizaci&oacute;n de la firma</strong></h2>
  <table style="border-collapse: collapse; width: 100%; height: 46px;" border="0">
<tbody>
<tr style="height: 5px;">
<td style="width: 45%; height: 18px; text-align: center;">firma</td>
<td style="width: 10%; height: 18px; text-align: center;">&nbsp;</td>
<td style="width: 45%; height: 18px; text-align: center;">&nbsp;</td>
</tr>
<tr style="height: 5px;">
<td style="width: 45%; height: 10px; text-align: center;">_________________________</td>
<td style="width: 10%; height: 10px; text-align: center;">&nbsp;</td>
<td style="width: 45%; height: 10px; text-align: center;">_________________________</td>
</tr>
<tr style="height: 5px;">
<td style="width: 45%; height: 18px; text-align: center;"><strong>El Empleador</strong></td>
<td style="width: 10%; height: 18px; text-align: center;">&nbsp;</td>
<td style="width: 45%; height: 18px; text-align: center;"><strong>El Trabajador</strong></td>
</tr>
</tbody>
</table>`

  const handleContentChange = (value) => {
    let firma = value;
    firma = firma.replaceAll('<p>', '')
    firma = firma.replaceAll('src="', 'height="100px" src="')
    firma = firma.replaceAll('</p>', '')
    setContent(firma);
    let html = document.getElementsByClassName('ql-editor')[0].innerHTML;
    if (html.search("img") >= 1) {
      html = html.replaceAll('p>', 'center>')
      html = tableFirma.replaceAll('>firma</td>', `>${html}</td>`)
    }


    setHtmlContent(html);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    //Verificar que todos los campos fueron llenados

    if (content.length !== 0 && DNI.length !== 0) {

      //Grabar plantilla
      const infoDocumento = {
        firma: content,
        DNI: DNI,
        fechaFirma: serverTimestamp(),
        ruc: ruc,
      };

      const result = await añadirDocumento(infoDocumento, usuario.email, `firmas`, `Grabar Firma`)
      console.log(result)
      // Add a new document with a generated id.
      /*const docRef = await addDoc(collection(db, "plantillaDocumentos"), {
        nombre: title,
        documento: htmlContent,
        codigo: codigo,
        activo: true,
        fechaDoc: serverTimestamp(),
        ruc: ruc,
      });
      console.log("Document written with ID: ", docRef.id);*/
      if (result.length === 20) {
        alertaOk(`Plantilla gaurdada con éxito`)
      } else {
        alertaError("No se guardo la plantilla, intentelo nuevamente")
      }
    } else {
      alertaError("Completa todos los campos porfavor.")
    }

  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit}>
        <div>
          <input
            type="text"
            value={DNI}
            onChange={(e) => setDNI(e.target.value)}
            placeholder="DNI del Firmante."
          />
        </div>

        <div style={{ display: 'inline-block', width: '100%', backgroundColor: 'white', marginTop: '20px', marginBottom: '20px' }}>
          <div style={{ float: 'left', width: '50%' }}>
            <ReactQuill
              modules={module}
              theme="snow"
              value={content}
              onChange={handleContentChange}
              placeholder="Inserte la firma mediante el icono de imagen, que se encuentra en la parte superior"
            />
          </div>

          <div dangerouslySetInnerHTML={{ __html: htmlContent }}
            style={{
              float: 'left',
              width: '50%',
              paddingLeft: '10px',
              border: '1px solid #D3D3D3',
              padding: '10px',
              backgroundColor: 'white',
              fontSize: '13px'
            }} />

          {/*
          Contenedor para ver las etiquetas HTML*/}
          
          <div>
            <textarea value={content} readOnly
            style={{ 
              width: '100%',
              height: '400px',
            }} />
          </div>
        </div>
        {/*<div>
        <label>Fecha:</label>
        <input
          type="text"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        </div>*/}

        <button type="submit">Publicar</button>
      </form>
    </div>
  );
};

export default GenerarDocumentos;
